import { pageMetaOwnsTitle } from './pageMeta'

const APP_TITLE = 'MyCo+'

export function formatDocumentTitle(companyName) {
  const name = String(companyName || '').trim()
  return name ? `${name} | ${APP_TITLE}` : APP_TITLE
}

/**
 * Logged-in app title: `{company} | MyCo+`.
 * Skips when a marketing/legal route owns the document head via pageMeta.
 */
export function setDocumentTitle(companyName) {
  if (pageMetaOwnsTitle()) return
  document.title = formatDocumentTitle(companyName)
}
